import { TemplateModulesModalTabsEnum } from '../../../../widgets/modules-modal/private-template-modules-modal/model/types';

export const URI_SETTINGS_UPDATE = 'auth';

export const DEFAULT_SETTINGS = {
	modal_module_tab_default: TemplateModulesModalTabsEnum.GALLERY,
};
